import withBoundary from 'component/ErrorBoundary/withBoundary';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'store/modules/base/redux';
import { getOverlayToRender } from 'store/modules/overlay';

/**
 * Implements a React {@link Component} that will display the correct overlay
 * when needed.
 */
class OverlayContainer extends Component {
  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @public
   * @returns {ReactElement|null}
   */
  render() {
    const { overlay } = this.props;

    return overlay ? React.createElement(overlay, {}) : null;
  }
}

/**
 * Maps (parts of) the redux state to the associated {@code OverlayContainer}'s
 * props.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {{
 *     overlay: ?Object
 * }}
 */
function _mapStateToProps(state) {
  return {
    /**
     * The React {@link Component} type of overlay to be rendered by the
     * associated {@code OverlayContainer}.
     */
    overlay: getOverlayToRender(state)
  };
}
OverlayContainer.propTypes = {
  overlay: PropTypes.any
};
export default connect(_mapStateToProps)(withBoundary(OverlayContainer));
